export const filterReocringsList = (filterMap?: Map<string, any>) => {
  if (filterMap) {
    const analysTypes = new Set<string>();
    const straightAnalysis = filterMap.get('straightAnalysisType');
    const longeingAnalysis = filterMap.get('longeingAnalysisType');
    const tooShortSaveAnalysis = filterMap.get('tooShortSaveAnalysisType');
    if (straightAnalysis) {
      analysTypes.add('straight');
    } else {
      analysTypes.delete('straight');
    }
    if (longeingAnalysis) {
      analysTypes.add('longeing');
    } else {
      analysTypes.delete('longeing');
    }
    if (tooShortSaveAnalysis && straightAnalysis && longeingAnalysis) {
      analysTypes.add('save');
    } else {
      analysTypes.delete('save');
    }
    return Array.from(analysTypes);
  }
  return Array.from([]);
};
